import Youtube from "./youtube";
new Youtube();